<div
  class="splash-screen linear-background"
>
  <img
    class="img-css"
    style="
      position: relative;
      -webkit-animation: floatBubble 2s infinite normal ease-out;
      animation: floatBubble 2s infinite normal ease-out;
    "
    src="../../../../assets/icon/logowhite.png"
    alt=""
  />
</div>
